import {MemexColumnDataType} from '../../../../../api/columns/contracts/memex-column'
import {asCustomNumberValue} from '../../../../../helpers/parsing'
import type {NumberColumnModel} from '../../../../../models/column-model/custom/number'
import type {TableDataType} from '../../../table-data-type'

export const readNumberCellClipboardContent = (row: TableDataType, column: NumberColumnModel) => {
  const customColumnValue = row.columns[column.id]
  const value = asCustomNumberValue(customColumnValue) || undefined

  return {
    text: value ? value.value.toString() : '',
    dataType: MemexColumnDataType.Number,
    value,
  }
}
